<ng-template #content>
  <div
    class="ss-dialog ss-dialog--{{ size }} ss-dialog--{{ tone }}"
    [attr.role]="tone === 'default' ? 'dialog' : 'alertdialog'"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
    ssTooltipRoot
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true">
    <span class="ss-dialog__handle" aria-hidden="true"></span>
    <header class="ss-dialog__header">
      <span class="ss-dialog__icon" aria-hidden="true">
        <lucide-icon [name]="icon || (tone === 'default' ? 'info' : 'triangle-alert')" [size]="26"></lucide-icon>
      </span>
      <h2 class="ss-dialog__title" [id]="titleId">{{ title }}</h2>
      <button type="button" class="ss-dialog__close" aria-label="Fechar" [disabled]="busy" (click)="requestClose()">
        <lucide-icon name="x" [size]="18" aria-hidden="true"></lucide-icon>
      </button>
    </header>

    <div class="ss-dialog__body" [class.ss-dialog__body--visible]="overflowVisible">
      <ng-content></ng-content>
    </div>

    <footer class="ss-dialog__footer">
      <ng-content select="[ssDialogActions]"></ng-content>
    </footer>
  </div>
</ng-template>
